/** Picture catalog (SPEC §9.5): key → Vietnamese name. Every key is drawn in `art/icons/<key>.svg`. */
export const ASSETS: Record<string, { vi: string }> = {
  egg: { vi: "quả trứng" },
  rose: { vi: "bông hoa hồng" },
  bird: { vi: "con chim" },
  fish: { vi: "con cá" },
  tangerine: { vi: "quả cam" },
  child: { vi: "bạn nhỏ" },
  pig: { vi: "con lợn" },
  flower: { vi: "bông hoa" },
  duck: { vi: "con vịt" },
  canoe: { vi: "chiếc thuyền" },
  rowboat: { vi: "chiếc thuyền" },
  apple: { vi: "quả táo" },
  chair: { vi: "chiếc ghế" },
  crayon: { vi: "bút sáp" },
  rabbit: { vi: "con thỏ" },
  cat: { vi: "con mèo" },
  dog: { vi: "con chó" },
  chicken: { vi: "con gà" },
  bus: { vi: "xe buýt" },
  bee: { vi: "con ong" },
  star: { vi: "ngôi sao" },
  coin: { vi: "đồng xu" },
  honey: { vi: "hũ mật" },
  trophy: { vi: "cúp" },
  lock: { vi: "khoá" },
  glowing_star: { vi: "ngôi sao sáng" },
  candy: { vi: "cái kẹo" },
  brain: { vi: "bộ não" },
  calendar: { vi: "tờ lịch" },
  books: { vi: "chồng sách" },
  lightning: { vi: "tia chớp" },
  game: { vi: "tay cầm trò chơi" },
  scissors: { vi: "cái kéo" },
  balance_scale: { vi: "cái cân" },
  droplet: { vi: "giọt nước" },
  cup: { vi: "cái cốc" },
  backpack: { vi: "cặp sách" },
  paper: { vi: "tờ giấy" },
  alarm_clock: { vi: "đồng hồ báo thức" },
  potted_plant: { vi: "chậu cây" },
  lantern: { vi: "đèn lồng" },
  globe: { vi: "quả địa cầu" },
  teddy: { vi: "gấu bông" },
  kite: { vi: "cánh diều" },
  sunflower: { vi: "hoa hướng dương" },
  rocket: { vi: "tên lửa" },
  tropical_fish: { vi: "cá cảnh" },
  party_popper: { vi: "pháo giấy" },
  balloon: { vi: "bóng bay" },
  shield: { vi: "cái khiên" },
  marble: { vi: "viên bi" },
  tomato: { vi: "quả cà chua" },
};

/**
 * Hand-drawn SVG pictures (T4.12, no emoji, D39): `art/icons/<key>.svg`, served with a content
 * hash so a redrawn picture reaches every device at once.
 */
const ICONS = Object.fromEntries(
  Object.entries(
    import.meta.glob<string>("./icons/*.svg", { query: "?url", import: "default", eager: true }),
  ).map(([path, url]) => [path.slice("./icons/".length, -".svg".length), url]),
);

export function assetSrc(key: string): string | null {
  return ICONS[key] ?? null;
}
